export default {
  hero_title: "Effortlessly Achieve EU CBAM Carbon Compliance",
  hero_subtitle:
    "A carbon calculation platform designed for SMEs, based on EU official/custom factors, to quickly generate compliant reports.",
  what_is_taxecobit: "What is TaxEcoBit?",
  taxecobit_description:
    "TaxEcoBit is a compliance automation platform built for businesses affected by the EU Carbon Border Adjustment Mechanism (CBAM). We help importers, manufacturers, and SMEs calculate product-level carbon emissions, generate CBAM-compliant reports, and reduce regulatory risks.",
  taxecobit_benefits: "With TaxEcoBit, users can:",
  benefit_accurate_calculations:
    "Perform accurate carbon calculations using official and custom emission factors",
  benefit_cbam_documents: "Generate submission-ready CBAM documentation",
  benefit_carbon_cost_tracking: "Monitor carbon cost impact and optimize operational efficiency",
  benefit_api_integration:
    "Seamlessly integrate compliance workflows via API with ERP and supply chain systems",
  taxecobit_conclusion:
    "By replacing manual spreadsheets and consulting dependency, TaxEcoBit enables faster, more reliable compliance at a lower operational cost.",
  register_now: "Sign Up Now",
  experience_calculator: "Try CBAM Calculator",
  try_cbam_calculator: "Try CBAM Calculator",
  try_cbam_quick_check: "Try CBAM Quick Check",
  download_sample_report: "Download Sample Report",
  pdf_report: "PDF Report",
  excel_report: "Excel Report",
  precise: "Precise",
  how_it_works: "How it works",
  precise_description:
    "Based on EU official/custom factors, with calculation error < 5%, meeting compliance requirements.",
  efficient: "Efficient",
  efficient_description:
    "Supports batch calculations, automatically generates PDF/Excel reports with flexible configuration.",
  sme_focused: "SME-Focused",
  sme_focused_description:
    "No professional background required, user-friendly interface for quick adoption.",
  api_support: "API Support",
  api_support_description:
    "Easily integrate with ERP/e-commerce systems for automated compliance reporting.",
};
